<template>
	<div class="anniversary">
		<v-herdes></v-herdes>
		<div class="anniversarys">
			<div class="anniversarys_left">
				<img class="board" src="../assets/images/ann/2nd(1).png" alt />
				<p class="anniversarys_left_text">
					Mahjong Soul cheerfully celebrates our 7th anniversary. We
					sincerely appreciate your support throughout these 7 years.
					<br />Since we have received so many heart-warming messages
					in the <br />#7th-anniversary-shrine channel on our official
					Discord, we decided to pick some of the messages and post
					them here. <br />Thank you for your love, we're looking
					forward to more happy years to come, nyaa~
				</p>
			</div>
			<div class="right-wrapper">
				<div class="anniversarys_right_navBox">
					<div class="nav-arrow left" @click="prevYear">
						<img
							src="../assets/images/ann/left-arrow.png"
							alt="prev"
						/>
					</div>
					<div class="nav-arrow right" @click="nextYear">
						<img
							src="../assets/images/ann/right-arrow.png"
							alt="next"
						/>
					</div>
					<div class="inner" ref="navContainer">
						<div
							v-for="(item, index) in navlist"
							:key="index"
							:ref="`navItem-${item.id}`"
							class="nav"
							:class="item.id == year ? 'nav-active' : ''"
							@click="yearClick(item.id)"
						>
							<div class="textBox">
								<span>{{ item.text }}</span>
								<span v-if="$utils.isPC()">Anniversary</span>
							</div>
							<div class="active_text" v-show="item.id == year">
								<span>{{ item.text }}</span>
								<span v-if="$utils.isPC()">Anniversary</span>
							</div>
						</div>
					</div>
				</div>
				<div class="anniversarys_right">
					<div class="anniversarys_right_playerid">
						<img
							class="rectangle"
							src="../assets/images/ann/rectangle.png"
							alt
						/>
						<!-- PC -->
						<vue-custom-scrollbar
							class="scroll-area"
							:settings="settings"
							v-if="$utils.isPC()"
						>
							<ul class="playerid">
								<li
									class="text"
									v-for="(
										PlayerIn, index
									) in currentPlayerInformation"
									:key="index"
								>
									<div class="Avatar">
										<img :src="PlayerIn.imgUrl" alt />
									</div>
									<div class="players">
										{{ PlayerIn.name }}
										<span>{{ PlayerIn.exception }}</span>
										<img
											class="arrow"
											src="../assets/images/ann/PLAYERs.png"
											alt
										/>
									</div>
									<div class="Narrative">
										<p
											class="Narratives"
											v-html="PlayerIn.texts"
										></p>
										<img
											class="paw"
											src="../assets/images/ann/paw.png"
											alt
										/>
									</div>
								</li>
							</ul>
						</vue-custom-scrollbar>

						<!-- mobile -->
						<ul class="playerid" v-if="!$utils.isPC()">
							<li
								class="text"
								v-for="(
									PlayerIn, index
								) in currentPlayerInformation"
								:key="index"
							>
								<div class="Avatar">
									<img :src="PlayerIn.imgUrl" alt />
								</div>
								<div class="players">
									{{ PlayerIn.name }}
									<span>{{ PlayerIn.exception }}</span>
									<img
										class="arrow"
										src="../assets/images/ann/PLAYERs.png"
										alt
									/>
								</div>
								<div class="Narrative">
									<p
										class="Narratives"
										v-html="PlayerIn.texts"
									></p>
									<img
										class="paw"
										src="../assets/images/ann/paw.png"
										alt
									/>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
import Footer from "@/components/footer.vue";
import herdes from "@/components/herdes.vue";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import { player } from "../data/config";
export default {
	name: "anniversary",

	components: {
		"v-herdes": herdes,
		"v-footer": Footer,
		vueCustomScrollbar,
	},
	data: () => ({
		settings: {
			suppressScrollY: false,
			suppressScrollX: false,
			wheelPropagation: false,
			minScrollbarLength: 50,
			maxScrollbarLength: 50,
			useBothWheelAxes: true,
			suppressScrollX: true,
		},
		settings2: {
			suppressScrollY: false,
			suppressScrollX: false,
			wheelPropagation: false,
			minScrollbarLength: 50,
			maxScrollbarLength: 50,
			useBothWheelAxes: true,
			suppressScrollX: true,
			handlers: ["click-rail", "keyboard", "wheel", "touch"],
		},
		year: 7,
		navlist: [
			{ text: "7th", id: 7 },
			{ text: "6th", id: 6 },
			{ text: "5th", id: 5 },
			{ text: "4th", id: 4 },
			{ text: "3rd", id: 3 },
			{ text: "2nd", id: 2 },
			{ text: "1st", id: 1 },
		],
		players: {},
	}),
	created() {},
	mounted() {
		const cachePlayer = localStorage.getItem("player");
		if (
			!!cachePlayer &&
			JSON.parse(cachePlayer).version === player.version
		) {
			console.log("from cache");
			this.players = JSON.parse(cachePlayer);
		} else {
			console.log("from config");
			localStorage.setItem("player", JSON.stringify(player));
			this.players = player;
		}
	},
	watch: {},
	computed: {
		currentPlayerInformation() {
			return this.players[this.year - 1];
		},
	},
	methods: {
		prevYear() {
			const currentIndex = this.navlist.findIndex(
				(item) => item.id === this.year
			);
			const nextIndex = Math.max(currentIndex - 1, 0);
			this.year = this.navlist[nextIndex]?.id || this.year;
			this.$nextTick(this.scrollToActiveNav);
		},

		nextYear() {
			const currentIndex = this.navlist.findIndex(
				(item) => item.id === this.year
			);
			const prevIndex = Math.min(
				currentIndex + 1,
				this.navlist.length - 1
			);
			this.year = this.navlist[prevIndex]?.id || this.year;
			this.$nextTick(this.scrollToActiveNav);
		},

		scrollToActiveNav() {
			const container = this.$refs.navContainer;
			const activeNav = this.$refs[`navItem-${this.year}`]?.[0];

			if (!activeNav || !container) return;

			// 计算滚动位置
			const containerWidth = container.offsetWidth;
			const navLeft = activeNav.offsetLeft;
			const navWidth = activeNav.offsetWidth;

			// 计算居中滚动位置
			const targetScrollLeft = navLeft - (containerWidth - navWidth) / 2;

			// 边界检查
			const maxScroll = container.scrollWidth - containerWidth;
			const finalScrollLeft = Math.max(
				0,
				Math.min(targetScrollLeft, maxScroll)
			);

			// 平滑滚动
			container.scrollTo({
				left: finalScrollLeft,
				behavior: "smooth",
			});
		},

		yearClick(index) {
			this.year = index;
			this.$nextTick(this.scrollToActiveNav);
		},
	},
};
</script>

<style lang="scss" scoped>
.anniversary {
	.anniversarys {
		margin-top: 4%;
		height: pxTorem(588px);
		width: 100%;
		background: url(../assets/images/ann/bk.png);
		background-size: 100% 100%;
		display: flex;
		justify-content: space-between;
		@media screen and (max-width: 600px) {
			height: MpxTorem(742px);
			margin-top: MpxTorem(50px);
			background: url(../assets/images/ann/bks5.png);
			background-size: 100% 100%;
			flex-direction: column;
		}

		.anniversarys_left {
			width: 45%;
			overflow: hidden;

			@media screen and (max-width: 600px) {
				display: block;
				width: 100%;
			}

			.board {
				width: pxTorem(496px);
				margin: pxTorem(80px) 0 0 pxTorem(30px);
			}

			.anniversarys_left_text {
				font-size: pxTorem(16px);
				font-family: "board";
				line-height: pxTorem(22px);
				width: pxTorem(362px);
				margin-left: 28%;
				margin-top: 1%;
				text-shadow: 0px 0px pxTorem(8px) #fff;

				@media screen and (max-width: 600px) {
					margin-left: 20%;
				}
			}
		}
		.right-wrapper {
			width: 60%;
			overflow: hidden;
			padding-left: 3%;

			@media screen and (max-width: 600px) {
				display: block;
				width: 100%;
			}

			.anniversarys_right_text {
				font-size: pxTorem(16px);
				font-family: "board";
				line-height: pxTorem(22px);
				width: pxTorem(362px);
				margin-left: 28%;
				margin-top: 1%;
				text-shadow: 0px 0px pxTorem(8px) #fff;

				@media screen and (max-width: 600px) {
					margin-left: 20%;
				}
			}
		}
		.anniversarys_right_navBox {
			//margin-left: pxTorem(10px);
			margin-top: pxTorem(103px);
			margin-right: pxTorem(80px);
			transform: translateY(pxTorem(7px));
			width: pxTorem(657px);
			padding: 0 pxTorem(40px);

			.inner {
				display: flex;
				align-items: flex-end;
				position: relative;
				overflow-x: auto;
				scroll-behavior: smooth;
				box-sizing: border-box;

				&::-webkit-scrollbar {
					display: none;
				}
			}

			@media screen and (max-width: 600px) {
				margin-top: MpxTorem(13px);
				margin-left: 7%;
				width: 86%;
				padding: 0 6%;
				box-sizing: border-box;
			}

			.nav {
				font-family: "hkkl";
				border-radius: pxTorem(8px);
				color: #f6efba;
				font-size: pxTorem(14px);
				background-color: #574c41;
				border: pxTorem(3px) solid #ab6c1b;
				cursor: pointer;
				position: relative;
				width: pxTorem(130px);
				height: pxTorem(46px);
				flex-shrink: 0;

				.textBox {
					display: flex;
					flex-direction: column;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
				}

				.active_text {
					display: flex;
					flex-direction: column;
					position: absolute;
					top: 50%;
					-webkit-text-stroke: initial;
					left: 50%;
					transform: translate(-50%, -50%);
				}

				&-active {
					width: pxTorem(160px);
					height: pxTorem(50px);
					color: #ffe692;
					background-color: #fcf5be;
					font-size: pxTorem(20px);
					border-radius: pxTorem(10px);
					border: pxTorem(7px) solid #8d6e37;
					-webkit-text-stroke: pxTorem(5px) #796753;
					cursor: initial;
				}
			}

			.nav-arrow {
				position: absolute;
				z-index: 2;
				top: pxTorem(8px);
				cursor: pointer;

				img {
					width: pxTorem(24px);
				}

				&.left {
					left: 0;
				}

				&.right {
					right: 0;
				}
			}
		}

		.anniversarys_right {
			position: relative;
			z-index: 1;
			box-sizing: border-box;
			padding: pxTorem(24px) pxTorem(20px) 0 pxTorem(28px);
			min-height: pxTorem(376px);
			margin-right: pxTorem(80px);
			width: pxTorem(657px);
			overflow: hidden;
			border-radius: pxTorem(10px);
			background: linear-gradient(
				to top,
				rgba(0, 0, 0, 0) 10%,
				#faede0 100%
			);
			box-shadow: 0 pxTorem(-10px) pxTorem(10px) rgba(0, 0, 0, 0.11);

			@media screen and (max-width: 600px) {
				display: block;
				background: linear-gradient(
					to top,
					#f9f2c6 20%,
					#f3eada 60%,
					#fcfaf7 80%
				);
				height: MpxTorem(376px);
				width: 87%;
				margin: 0 MpxTorem(24px);
				padding: MpxTorem(24px) MpxTorem(5px) 0 MpxTorem(28px);
			}

			.anniversarys_right_playerid {
				position: relative;
				height: 500px;

				@media screen and (max-width: 600px) {
					height: 100%;
					overflow-y: auto;
					overflow-x: hidden;
				}

				.playerid {
					.text {
						text-align: center;
						box-sizing: border-box;
						padding: pxTorem(27px) pxTorem(15px) pxTorem(0px)
							pxTorem(15px);
						width: pxTorem(533px);
						background: #cdd4ac;
						border-radius: pxTorem(10px);
						margin: pxTorem(30px) 0 pxTorem(60px) pxTorem(24px);
						position: relative;

						@media screen and (max-width: 600px) {
							width: MpxTorem(240px);
							font-family: "board";
						}

						.players {
							background: url(../assets/images/ann/PLAYER.png);
							height: pxTorem(18px);
							background-size: 100% 100%;
							display: block;
							position: absolute;
							white-space: nowrap;
							top: pxTorem(-10px);
							left: pxTorem(56px);
							line-height: pxTorem(0px);
							padding: 0 pxTorem(8px);
							font-weight: 900;
							color: #fcf5be;
							font-family: "board";
							text-shadow: 0px 0px pxTorem(8px) #ab6c1c,
								0px 0px pxTorem(8px) #ab6c1c,
								0px 0px pxTorem(8px);
							-webkit-text-stroke: pxTorem(2px) #ab6c1c;
							font-size: pxTorem(30px);

							@media screen and (max-width: 600px) {
								text-shadow: 0px 0px MpxTorem(1px) #ab6c1c,
									0px 0px MpxTorem(1px) #ab6c1c,
									0px 0px MpxTorem(1px);
								-webkit-text-stroke: MpxTorem(1px) #ab6c1c;
								// letter-spacing:1px;
							}

							.arrow {
								height: pxTorem(18px);
								position: absolute;
								right: pxTorem(-20px);
								top: 0;

								@media screen and (max-width: 600px) {
									right: pxTorem(-15px);
								}
							}

							span {
								text-shadow: none;
								-webkit-text-stroke: pxTorem(0px) #ab6c1c;
							}

							.dast {
								font-weight: 900;
								color: #fcf5be;
								font-family: "board";
								text-shadow: 0px 0px MpxTorem(1px) #ab6c1c,
									0px 0px MpxTorem(1px) #ab6c1c,
									0px 0px MpxTorem(1px);
								-webkit-text-stroke: MpxTorem(1px) #ab6c1c;
								font-size: pxTorem(30px);
								line-height: MpxTorem(18px);
								display: block;
								transform: translateY(MpxTorem(-15px));
								text-align: left;
							}
						}

						.Avatar {
							left: pxTorem(-22px);
							top: pxTorem(-30px);
							width: pxTorem(72px);
							height: pxTorem(72px);
							border: pxTorem(7px) solid #b1752a;
							border-radius: 50%;
							position: absolute;
							z-index: 2;
							overflow: hidden;

							img {
								width: 100%;
							}
						}

						.Narrative {
							z-index: 1;

							p {
								font-family: "boards";
								font-weight: 600;
								font-size: pxTorem(16px);
								line-height: pxTorem(28px);
								z-index: 222;

								@media screen and (max-width: 600px) {
									font-family: "boards";
									line-height: MpxTorem(16px);
									letter-spacing: -0.5px;
								}
							}

							.Narratives {
								text-align: left;
								word-break: break-word;
								text-indent: 3em;
							}

							.paw {
								width: pxTorem(27px);
								// display: block;
								// position: absolute;
								margin-left: pxTorem(400px);
								margin-bottom: pxTorem(10px);

								@media screen and (max-width: 600px) {
									margin-left: MpxTorem(180px);
									margin-bottom: MpxTorem(10px);
								}
							}
						}
					}
				}

				.rectangle {
					height: 100%;
					position: absolute;
					//    top: pxTorem(170px);
					//    right: pxTorem(110px);
					right: pxTorem(5px);

					@media screen and (max-width: 600px) {
						display: none;
					}
				}

				.scroll-area {
					position: relative;
					margin: 0;
					height: 100%;
				}

				::v-deep.el-scrollbar {
					width: pxTorem(610px);
					height: 100%;

					@media screen and (max-width: 600px) {
						width: pxTorem(460px);
						overflow: hidden;
					}
				}

				::v-deep.el-scrollbar__bar {
					@media screen and (max-width: 600px) {
						display: none;
					}

					&.is-vertical {
						width: pxTorem(26px); //滚动条宽度
						height: 100px;
					}
				}

				::v-deep.is-vertical {
					&.is-vertical {
						width: pxTorem(18px); //滚动条宽度
						height: pxTorem(340px);
					}
				}

				::v-deep.el-scrollbar__wrap {
					overflow-y: auto;
					overflow-x: hidden;
				}

				::v-deep.el-scrollbar__thumb {
					background: #e8c47c;
					// height: pxTorem(30px)!important;
					background: url(../assets/images/ann/PLAYER.png);

					// border: radius 5px solid #a96816;
					@media screen and (max-width: 600px) {
						background: #000;
						// height: pxTorem(30px)!important;
						display: none;

						border: radius 5px solid #a96816;
					}
				}

				::v-deep.el-scrollbar__thumb::after {
					background: black;
					height: 100px;
					width: 100px;
					z-index: 999;
					position: absolute;
					right: 0;
				}

				// .el-scrollbar{

				// }
			}
		}
	}
}
</style>
